<template>
    <div>
        <gmap-map
            ref="gmap"
            :center="center"
            :zoom="zoom"
            :options="mapOptions">
            <gmap-marker
                v-for="(mark, index) in getMarkers"
                :key="index"
                :position="mark.position"
                :icon="mark.icon"
                :communityId="mark.communityId"
                :data-qe-id="`map-marker_${index}`"
                @mouseover="openInfoWindow(mark)"
                @click="openAssetWindow(mark)">
                <gmap-info-window
                    v-if="selectedMarker == mark"
                    :position="selectedMarker.position"
                    :opened="infoBoxOpen"
                    @closeclick="infoBoxOpen = false;">
                    <div class="infoWindow">
                        <router-link v-if="!isBusinesses" :to="{ path:`/chapter/${selectedMarker.communityId}`}" data-qe-id="map-marker_selected-mark">
                            {{selectedMarker.title}}
                        </router-link>
                        <a v-if="isBusinesses" @click="openBusinessesInfo(mark)" data-qe-id="map-marker_businesses_link">{{selectedMarker.title}} </a>
                    </div>
                </gmap-info-window>
            </gmap-marker>
        </gmap-map>
    </div>
</template>

<script>
    import { ypoMapConstant } from "../YpoMap/ypoMap.constant";
    import { mapMutations } from "vuex";
    import { storeMutation } from "../../store/storeMutations.constant";
    import { menuOptions } from "../appCommon.constants";

    export default {
        name: "YpoMap",
        props: {
            mapList: {
                type: Array,
                required: true,
            },
            centerTo: {
                type: Object,
                default: () => ({}),
            },
            zoom: {
                type: Number,
                default: 3,
                required: false,
            },
        },
        data() {
            return {
                mapOptions: {
                    mapTypeControl: false,
                    fullscreenControl: false,
                    streetViewControl: false,
                    minZoom: 3,
                },
                center: {},
                places: [],
                currentPlace: null,
                selectedMarker: null,
                infoBoxOpen: false,
                mapIcon: [],

            };
        },
        mounted() {
            this.geolocate();
        },
        computed: {
            getMarkers() {
                if (this.mapList) {
                    return this.addMarker(this.mapList);
                }
            },
            isBusinesses() {
                return this.$route.path.toLowerCase().includes(menuOptions.BUSINESSES.toLowerCase());
            },
        },
        methods: {
            addMarker(data) {
                const markers = [];
                const mapIconList = ypoMapConstant.mapIcons;
                data.forEach((element) => {
                    if (element.latitude && element.longitude) {
                        let mapIcon;
                        if (element.isIntegrated) {
                            [mapIcon] = mapIconList.filter(item => item.key === ypoMapConstant.YPO_Integrated_Chapter).map(item => item.value);
                        } else {
                            [mapIcon] = mapIconList.filter(item => item.key === element.ypoIType).map(item => item.value);
                        }

                        const position = {
                            lat: element.latitude,
                            lng: element.longitude,
                        };

                        markers.push({
                            position,
                            title: element.name,
                            icon: mapIcon,
                            communityId: element.communityId,
                            id: element.id ? element.id : '',
                        });
                    }
                });
                return markers;
            },
            geolocate() {
                if (!this.centerTo || Object.keys(this.centerTo).length === 0) {
                    navigator.geolocation.getCurrentPosition((position) => {
                        this.center = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        };
                    });
                } else {
                    this.center = this.centerTo;
                }
            },
            openInfoWindow(marker) {
                this.selectedMarker = marker;
                this.infoBoxOpen = true;
            },
            openBusinessesInfo(mark) {
                this.setShowAssetId(mark.id);
            },
            openAssetWindow(mark) {
                this.center = mark.position;
                if (this.isBusinesses) {
                    this.openBusinessesInfo(mark);
                }
            },
            ...mapMutations({
                setShowAssetId: `businesses/${[storeMutation.setShowAssetId]}`,
            }),
        },
        watch: {
            centerTo(val) {
                if (val) {
                    this.$refs.gmap.$mapPromise.then((map) => {
                        /* eslint-disable-next-line no-undef*/
                        const bounds = new google.maps.LatLngBounds();
                        bounds.extend(val);
                        map.fitBounds(bounds);
                        map.setZoom(10);
                    });
                }
            },
            mapList(val) {
                if (val && val.length > 0) {
                    this.$refs.gmap.$mapPromise.then((map) => {
                        /* eslint-disable-next-line no-undef*/
                        const bounds = new google.maps.LatLngBounds();
                        this.getMarkers.forEach((m) => {
                            /* eslint-disable-next-line no-undef*/
                            const loc = new google.maps.LatLng(m.position.lat, m.position.lng);
                            bounds.extend(loc);
                        });
                        map.fitBounds(bounds);      
                        map.panToBounds(bounds);
                    });
                }
            },
        },
    };
</script>

<style lang="scss">
    .ypoMap {
        .vue-map-container {
            height: 300px;
        }
    }
</style>
<style lang="scss" scoped>
    .infoWindow {
        a {
            text-decoration: underline;
        }
    }
</style>
